// import scrollIntoView from 'scroll-into-view-if-needed';

const SmoothScrollIntoView = () => {
	const scrollToLocation = (target) => {
		const header = document.querySelector('.main-header');
		const inpageMenu = document.querySelector('.block-nav-inpage-menu');
		// const utilityMenu = document.querySelector('.utility-menu');
		// const alertBar = document.querySelector('.block-alert-top');
		// const adminBar = document.getElementById('wpadminbar');

		const headerHeight = header ? header.offsetHeight : 0;
		const inpageMenuHeight = inpageMenu ? inpageMenu.offsetHeight : 0;
		// const utilityMenuHeight = utilityMenu ? utilityMenu.offsetHeight : 0;
		// const alertBarHeight = alertBar ? alertBar.offsetHeight : 0;
		// const adminBarHeight = adminBar ? adminBar.offsetHeight : 0;

		const element = document.getElementById(target);
		const elementTop = element.getBoundingClientRect().top + window.scrollY;
		const fixedElementsOffset =
			// adminBarHeight +
			// alertBarHeight +
			// utilityMenuHeight +
			headerHeight + inpageMenuHeight;
		const targetPosition = elementTop - fixedElementsOffset;

		const prefersReducedMotion = window.matchMedia(
			'(prefers-reduced-motion: reduce)'
		).matches;

		window.scrollTo({
			top: targetPosition,
			behavior: prefersReducedMotion ? 'auto' : 'smooth',
		});

		element.focus();

		// Monitor scroll to trigger event when complete
		monitorScroll(element, targetPosition);
	};

	const monitorScroll = (target, targetPosition) => {
		const checkScroll = () => {
			const currentScroll = window.scrollY;

			if (Math.abs(currentScroll - targetPosition) <= 1) {
				const event = new CustomEvent('anchorScrollComplete', {
					detail: {
						target,
						position: targetPosition,
					},
				});
				window.dispatchEvent(event);
			} else {
				requestAnimationFrame(checkScroll);
			}
		};

		requestAnimationFrame(checkScroll);
	};

	// get all links on a page that include a hash symbol. Ignore disabled links.
	const anchorsLinks = document.querySelectorAll(
		'a[href^="#"]:not([href="#"]):not([href="#onetrust"])'
	);

	if (anchorsLinks.length) {
		anchorsLinks.forEach(function (anchor) {
			anchor.addEventListener('click', function (e) {
				e.preventDefault();
				const target = anchor.getAttribute('href').substring(1);
				scrollToLocation(target);
			});

			anchor.addEventListener('keydown', function (e) {
				if (' ' === e.key || 'Enter' === e.key) {
					e.preventDefault();
					const target = anchor.getAttribute('href').substring(1);
					scrollToLocation(target);
				}
			});
		});
	}
};

export default SmoothScrollIntoView;
